import { FC } from 'react';
import { useTranslate } from 'hooks/useTranslate';

import { Transaction } from 'types';

import EmptyStateForTable from 'modules/_shared/components/EmptyStates/EmptyStateForTable';

import { useOperationDetailsPage } from '../../context/OperationDetailsPageContext';
import ReclassificationOperationTableRow from './ReclassificationOperationTableRow';
import { useGetReclassificationTransactions } from '../../hooks/useGetReclassificationTransactions';

const ReclassificationOperationTableBody: FC = () => {
  const { t } = useTranslate();

  const { data } = useOperationDetailsPage();

  const { data: reclassificationTransactionsData } =
    useGetReclassificationTransactions({
      reclassificationOperation: data.operation,
      isOldReclassification: data.isOldOperation,
    });

  const hasData = reclassificationTransactionsData.transactions.length > 0;

  return (
    <>
      {hasData ? (
        <tbody>
          {reclassificationTransactionsData.transactions?.map(
            (transaction: Transaction, index: number) => (
              <tr
                className="nk-tb-item"
                // eslint-disable-next-line react/no-array-index-key
                key={`reclassification-data-row-${index}`}
              >
                <ReclassificationOperationTableRow
                  index={index}
                  transaction={transaction}
                />
              </tr>
            )
          )}
        </tbody>
      ) : (
        <EmptyStateForTable
          mainMessage={t('NoDataFound')}
          infoMessage=""
          colspan={7}
        />
      )}
    </>
  );
};

export default ReclassificationOperationTableBody;
